import React, { Component } from 'react';
import ReactDom from 'react-dom';
import InvoiceList from '../InvoiceList';
import ReactPaginate from 'react-paginate';
import SorList from './SorList';

export default class SorSpreadsheets extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            offset: 0,
        };
    }

    loadSorSpreadsheetsFromServer() {
        $.ajax({
            url: this.props.url,
            data: { limit: this.props.perPage, offset: this.state.offset },
            dataType: 'json',
            type: 'GET',
            success: (data) => {
                this.setState({
                    data: data.spreadsheets,
                    pageCount: Math.ceil(data.total / this.props.perPage),
                });
            },
            error: (xhr, status, err) => {
                toastr.error('Could not load data from the server');
            },
        });
    }

    componentDidMount() {
        this.loadSorSpreadsheetsFromServer();
    }

    handlePageClick = (data) => {
        let selected = data.selected;
        let offset = Math.ceil(selected * this.props.perPage);

        this.setState({ offset: offset }, () => {
            this.loadSorSpreadsheetsFromServer();
        });
    };

    render() {
        return (
            <div>
                <SorList data={this.state.data} downloadUrl={this.props.downloadUrl} />
                <ReactPaginate
                    previousLabel={'previous'}
                    nextLabel={'next'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={this.state.pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={this.handlePageClick}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                />
            </div>
        );
    }
}

if (document.getElementById('sor-spreadsheets')) {
    let element = document.getElementById('sor-spreadsheets');

    ReactDom.render(
        <SorSpreadsheets
            downloadUrl={element.dataset.download_url}
            perPage={element.dataset.per_page}
            url={element.dataset.url}
        />,
        element
    );
}
